import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { setTerminalSecret, deleteTerminalSecret } from '../api/terminals';

export function SecretsPanel({ terminalId, secrets, onChange }) {
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleAdd(e) {
    e.preventDefault();
    if (!key.trim() || !value) return;
    setBusy(true);
    try {
      const updated = await setTerminalSecret(terminalId, key.trim(), value);
      onChange(updated.secrets);
      setKey('');
      setValue('');
    } finally {
      setBusy(false);
    }
  }

  async function handleDelete(secretKey) {
    const updated = await deleteTerminalSecret(terminalId, secretKey);
    onChange(updated.secrets);
  }

  return (
    <div className="panel-section">
      <p className="panel-help">
        Available in your handler as <code>context.secrets.KEY</code>. Values are encrypted at rest and
        cannot be viewed again after saving - only re-set or deleted.
      </p>
      <div className="secret-list">
        {secrets.length === 0 && <div className="muted">No secrets set.</div>}
        {secrets.map((s) => (
          <div key={s.key} className="secret-row">
            <code>{s.key}</code>
            <span className="muted">••••••••</span>
            <button className="icon-btn" onClick={() => handleDelete(s.key)} title="Delete">
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
      <form className="secret-form" onSubmit={handleAdd}>
        <input placeholder="KEY" value={key} onChange={(e) => setKey(e.target.value.toUpperCase())} />
        <input placeholder="value" type="password" value={value} onChange={(e) => setValue(e.target.value)} />
        <button className="btn btn-secondary" type="submit" disabled={busy}>
          <Plus size={14} />
          Set
        </button>
      </form>
    </div>
  );
}
